import { render, staticRenderFns } from "./CmsMemberDetail.vue?vue&type=template&id=6f108ca4&scoped=true"
import script from "./CmsMemberDetail.vue?vue&type=script&lang=js"
export * from "./CmsMemberDetail.vue?vue&type=script&lang=js"
import style0 from "./CmsMemberDetail.vue?vue&type=style&index=0&id=6f108ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f108ca4",
  null
  
)

export default component.exports